// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
// `.env.ts` is generated by the `npm run env` command
// import env from './.env';

let production = 'false';
let serverUrl = 'https://staging.relieftelemed.com/relief_api/v1/';
let errorTrackingEnv = 'staging';
let googleMapsKey = '';
let applicationVersion = '834136675fd63760f67a6b160ac623fbca4e48ba';
let customClasses = '';

export const environment = {
  production: production === 'true',
  serverUrl: serverUrl,
  errorTrackingEnv: errorTrackingEnv,
  applicationVersion: applicationVersion,
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'en-US',
    'fr-FR'
  ],
  googleMapsKey: googleMapsKey,
  customClasses: customClasses
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts